/**
 * @class Product
 */
export default class Product {
    /**
     * @param {Number}  id
     * @param {String}  name
     * @param {String}  displayName
     * @param {String}  code
     * @param {String}  group
     * @param {Boolean} enabled
     */
    constructor(id, name, displayName = "", code = "", group = "", enabled = true) {
        this._id = id;
        this._name = name;
        this._displayName = displayName;
        this._code = code;
        this._group = group;
        this._enabled = enabled;

        if (typeof this._id !== "number") {
            throw new Error("Invalid datatype of ID - Product");
        }
    }

    /**
     * @return {Number}
     */
    get id() {
        return this._id;
    }

    /**
     * @param {Number} id
     */
    set id(id) {
        this._id = id;
    }

    /**
     * @return {String}
     */
    get name() {
        return this._name;
    }

    /**
     * @param {String} name
     */
    set name(name) {
        this._name = name;
    }

    /**
     * @return {String}
     */
    get displayName() {
        return this._displayName;
    }

    /**
     * @param {String} displayName
     */
    set displayName(displayName) {
        this._displayName = displayName;
    }

    /**
     * @return {String}
     */
    get code() {
        return this._code;
    }

    /**
     * @param {String} code
     */
    set code(code) {
        this._code = code;
    }

    /**
     * @return {String}
     */
    get group() {
        return this._group;
    }

    /**
     * @param {String} group
     */
    set group(group) {
        this._group = group;
    }

    /**
     * @return {Boolean}
     */
    get enabled() {
        return this._enabled;
    }

    /**
     * @param {Boolean} enabled
     */
    set enabled(enabled) {
        this._enabled = enabled;
    }

    /**
     * @return {String}
     */
    toString() {
        return "Product (" + this._id + ")";
    }

    /**
     * @param   {Product}       product
     * @return  {String | null}
     */
    static serialize = (product) => {
        try {
            return (
                product.id +
                ";" +
                (product.name === null ? "null" : product.name.replace(/;/g, "")) +
                ";" +
                (product.displayName === null ? "null" : product.displayName.replace(/;/g, "")) +
                ";" +
                (product.code === null ? "null" : product.code.replace(/;/g, "")) +
                ";" +
                (product.group === null ? "null" : product.group.replace(/;/g, "")) +
                ";" +
                product.enabled
            );
        } catch (e) {
            return null;
        }
    };

    /**
     * @param   {String | null} product
     * @return  {Product | null}
     */
    static unserialize = (product) => {
        if (typeof product !== "string") {
            return null;
        }

        let productParts = product.split(";");

        if (productParts.length !== 6) {
            return null;
        }

        try {
            return new Product(
                Number(productParts[0]),
                productParts[1] === "null" ? null : productParts[1],
                productParts[2] === "null" ? null : productParts[2],
                productParts[3] === "null" ? null : productParts[3],
                productParts[4] === "null" ? null : productParts[4],
                productParts[5] === "true"
            );
        } catch (e) {
            return null;
        }
    };

    /**
     * @return {Object}
     */
    formatedObject() {
        return {
            id: this._id,
            name: this._name,
            displayName: this._displayName,
            code: this._code,
            group: this._group,
            enabled: this._enabled
        };
    }
}
